import { render, staticRenderFns } from "./TranServicePackageCreate.vue?vue&type=template&id=1f8ad889"
import script from "./TranServicePackageCreate.vue?vue&type=script&lang=js"
export * from "./TranServicePackageCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports